module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_List Widget

(function (fox, $) {
	'use strict';

	fox.registerWidget('Activity_Event_List', {

		configure: function () {
			this.collection = [];
			this.inDomCounter = 0;

			this.registerOptions('', {
				columns: [
					'#firts-column', '#second-column', '#third-column'
				],
				'widgetGroupInfo.widgetViewList.manualActivation': true
			});
			
			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('.Widget', {
				'hooks.onStopRendering': fox.isFunction(this.getOption('onStopRendering')) ? this.getOption('onStopRendering') : function () {},
				'hooks.onAddedToDom': fox.isFunction(this.getOption('onAddedToDom')) ? this.getOption('onAddedToDom') : function () {},
				'hooks.onStopAddedToDom': function () {
					setTimeout(fox.bind(function () {
						$(this.element).removeClass('fadeIn');
					}, this), 2005);
				}
			});

			if (this.getOption('collection')) {
				this.setCollection(this.getOption('collection'));
			}

			this.def = {
				autoRender: true,
				group: 'widgetViewList',
				dontReuseSn: true,
				embed: {
					location: 'lastChild',
					container: this.getOption('container') || this.getOption('embed.container')
				}
			};

			this.callParent('init', arguments);
		},

		setCollection: function (collection, notRender) {
			this.collection = collection;

			if (this.isRun()) {
				this.render();
			}
		},

		getCollection: function () {
			return this.collection;
		},

		running: function () {
			this.render();

			this.callParent('running', arguments);
		},

		activate: function () {
			this.render();	
		
			this.callParent('activate', arguments);
		},

		deactivate: function () {
			this.cleanMemo();
		
			this.callParent('deactivate', arguments);
		},

		render: function () {
			this.cleanMemo();

			fox.each(this.getCollection(), this._treatRow, this);
		},

		_treatRow: function (val, key) {
			this.hookWrapper('treatRow', {val: val, key: key});
		},

		treatRow: function (data) {
			var wClass, w, wAlias, cols;

			if ((cols = fox.clone(this.getOption('columns')))) {
				cols.unshift(cols.pop());

				this.def.embed.container = cols[(data.key + 1) % cols.length];
			}

			wClass = data.val.widget || this.getOption('wClass') || 'Widget';
			wAlias = ['activity', data.key].join('_');
			w = this.getEmbeddedWidget(wAlias);

			if (!w) {
				if (fox.isObject(data.val.typedParams) && ('length' in data.val.typedParams)) {
					data.val.typedParams._length = data.val.typedParams.length;
					delete data.val.typedParams.length;
				}

				w = this.embedWidget(wAlias, wClass, fox.merge(data.val, this.def));
				w.run();
			} else {
				w.activate();
			}
		},

		cleanMemo: function () {
			fox.each(this.getWidgetsByGroup('widgetViewList'), function (w) {
				w.removeSelf();
			});

			this._reactivationPool = [];
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/activity/event/list.js
// module id = 802
// module chunks = 4